import axios from "axios";
import Vue from "vue";

const version = "v1";
const baseUrl = `${version}/Addons`;
const getAddonsList = baseUrl + '/getAll';


export const state = Vue.observable({
	addonsList: [],
	addonsCount: 0,
});

export const mutations = {
	async getAddonsList(params = {}) {
		var res = await axios.post(getAddonsList, params);
		state.addonsList = res.data.result.items;
		state.addonsCount = res.data.result.totalCount;
	},
	async deleteAddon(id) {
		await axios.delete(baseUrl + '/' + id);
		await this.getAddonsList();
	},
	async updateAddon(addon) {
		await axios.put(baseUrl, addon);
		await this.getAddonsList();
	},
	async addAddon(addon) {
		await axios.post(baseUrl, addon);
		await this.getAddonsList();
	},
};
